import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function StickyContainer(props) {
  const containerRef = useRef(null);
  const [pageYOffset, setPageYOffset] = useState(window.pageYOffset);
  const [offsetTop, setOffsetTop] = useState(undefined);

  useEffect(() => {
    setOffsetTop(containerRef.current.offsetTop);
  }, []);

  useEffect(() => {
    const handleScroll = () => setPageYOffset(window.pageYOffset);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const isSticked = offsetTop !== undefined ? pageYOffset >= offsetTop : false;

  return (
    <div style={{ marginBottom: isSticked ? containerRef.current.clientHeight || 0 : 0 }}>
      <div
        className={classNames('sticky-container', {
          sticked: isSticked,
        })}
        ref={containerRef}
      >
        {props.children}
      </div>
    </div>
  );
}

StickyContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
